export default class TextAnimationOnScroll {
  init() {
    this.textAnimationContainerList = Array.from(
      document.getElementsByClassName('text-animation-on-scroll__container')
    );

    if (!this.textAnimationContainerList.length) {
      return;
    }

    this.updateAllTextAnimation();

    window.addEventListener(
      'scroll',
      () => {
        this.updateAllTextAnimation();
      },
      window.supportPassive
    );
  }

  updateAllTextAnimation() {
    for (let containerElement of this.textAnimationContainerList) {
      const textElement = containerElement.querySelector(
        '.text-animation-on-scroll__text'
      );

      this.updateTransformOnScroll(containerElement, textElement);
    }
  }

  updateTransformOnScroll(containerElement, textElement) {
    const textRect = textElement?.getBoundingClientRect();

    if (!textRect) {
      return;
    }

    const viewportArea = this.getViewportScrollableArea();
    const isInViewportArea =
      textRect.top > viewportArea.top &&
      textRect.top < this.getWindowHeight() - viewportArea.bottom;

    if (!isInViewportArea) {
      return;
    }

    const viewportRelativeTopPosition = textRect.top - viewportArea.top;

    const containerInnerWidth = this.getContainerInnerWidth(containerElement);

    const scrollPercent = 1 - viewportRelativeTopPosition / viewportArea.height;
    const widthDifference = textElement.offsetWidth - containerInnerWidth;

    textElement.style.setProperty('--scroll-percent', scrollPercent);

    textElement.style.transform = `translate3d(${Math.round(
      widthDifference * scrollPercent * -1
    )}px, 0, 0) rotateZ(0deg)`;
  }

  getViewportScrollableArea() {
    const top = this.getWindowHeight(0.2);
    const bottom = this.getWindowHeight(0);

    return {
      top,
      bottom,
      height: this.getWindowHeight() - top - bottom,
    };
  }

  getContainerInnerWidth(containerElement) {
    const containerStyles = getComputedStyle(containerElement);

    return (
      parseFloat(containerStyles.width) -
      parseFloat(containerStyles.paddingLeft) -
      parseFloat(containerStyles.paddingRight)
    );
  }

  getWindowHeight(percent = 1) {
    return (
      (window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight) * percent
    );
  }
}
